import Swal from "sweetalert2";
import { studentsList } from "../../../api/Student";
import DownloadExcel from "../../master/DownloadExcel";
import { SweetAlertShow } from "../../master/Master";
import { PrintPage } from "../../master/Print";
import { STUDENT_COLUMNS } from "./studentColumns";

export const getStudents = async ({ setLoading, filters, setData }) => {
  setLoading(true);
  let addUrl = "";
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      addUrl += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  try {
    const response = await studentsList(addUrl);
    if (response.data.status) {
      setData(response?.data?.data);
    } else {
      SweetAlertShow("info", "Warning", response?.data?.message);
    }
  } catch (error) {
    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ?? error?.response?.message,
    );
  } finally {
    setLoading(false);
  }
};

// export const handleStudentDownload = async (
//   type = "excel",
//   setLoading,
//   filters = {},
// ) => {
//   setLoading(true);

//   try {
//     const downloadData = [];
//     let firstUrl = "";
//     Object.keys(filters).forEach((key) => {
//       const value = filters[key];
//       if (value !== undefined && value !== null && value !== "") {
//         if (key !== "page") {
//           firstUrl += `&${key}=${encodeURIComponent(value)}`;
//         }
//       }
//     });

//     const firstResponse = await studentsList(`page=1${firstUrl}`);
//     if (!firstResponse?.data?.status) {
//       SweetAlertShow("info", "Warning", firstResponse?.data?.message);
//       return;
//     }

//     const lastPage = firstResponse?.data?.data?.last_page || 1;

//     const mapRows = (items) =>
//       items.map((item) => ({
//         "Student Name": item?.name ?? "",
//         "Registration No": item?.registration_no ?? "",
//         "Father Name": item?.father_name ?? "",
//         "Mother Name": item?.mother_name ?? "",
//         "Father Occupation": item?.father_occupation ?? "",
//         Mobile: item?.phone ?? "",
//         "Secondary Mobile": item?.secondary_mobile ?? "",
//         Course: item?.course_and_fee_info?.course?.title ?? "",
//         Batch: item?.course_and_fee_info?.batch?.title ?? "0",
//         Email: item?.email ?? "",
//         Address: `${item?.village ?? ""} ${item?.district ?? ""} ${item?.state ?? ""
//           } ${item?.pincode ?? ""}`,
//         aadhar: item?.aadhar ?? "",
//         Category: item?.category ?? "",
//         Gender: item?.gender ?? "",
//         dob: formatToDate(item?.dob) ?? "",
//         nic_id: item?.nic_id ?? "",
//         apaar_id: item?.apaar_id ?? "",
//         medium: item?.medium ?? "",
//         "Admission Date": formatToDate(item?.admission_date) ?? "",
//         "Manual_Remark ": "",
//         // "Old Due Fees": item?.old_due_fees ?? "",
//         // "Old Paid Fees": item?.old_paid_fees ?? "",
//         // "Old Fees Remark": item?.old_fees_remark ?? "",

//       }));

//     downloadData.push(...mapRows(firstResponse?.data?.data?.data || []));

//     for (let page = 2; page <= lastPage; page++) {
//       const response = await studentsList(`page=${page}${firstUrl}`);

//       if (response?.data?.status) {
//         downloadData.push(...mapRows(response?.data?.data?.data || []));
//       }
//     }

//     if (downloadData.length) {
//       if (type === "excel") {
//         const now = new Date();

//         const fileName = `Report_${now.getFullYear()}_${now.getMonth() + 1
//           }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

//         DownloadExcel(downloadData, [], fileName, []);
//       } else {
//         PrintPage(downloadData);
//       }
//     } else {
//       SweetAlertShow("info", "Info", "No records found");
//     }
//   } catch (err) {
//     SweetAlertShow(
//       "error",
//       "Error",
//       err?.response?.data?.message || err?.message,
//     );
//   } finally {
//     setLoading(false);
//   }
// };

export const handleStudentDownload = async (
  type = "excel",
  setLoading,
  filters = {},
) => {
  const COLUMN_STORAGE_KEY = "student_download_columns";

  const savedColumns = JSON.parse(
    sessionStorage.getItem(COLUMN_STORAGE_KEY) || "null",
  );

  const defaultSelected =
    Array.isArray(savedColumns) && savedColumns.length
      ? savedColumns
      : STUDENT_COLUMNS.map((c) => c.key);

  const popup = await Swal.fire({
    title: "",
    width: 760,
    padding: "0",
    showCancelButton: true,
    showDenyButton: true,

    denyButtonText: "Reset",
    cancelButtonText: "Cancel",
    confirmButtonText: type === "excel" ? "Download Excel" : "Print",

    buttonsStyling: true,

    customClass: {
      popup: "student-download-popup",
      confirmButton: "student-download-confirm",
      cancelButton: "student-download-cancel",
      denyButton: "student-download-reset",
    },

    html: `
      <div class="student-column-selector">

        <!-- Header -->
        <div class="student-column-header">

          <div class="student-column-title-section">
            <div class="student-column-icon">
              <i class="ri-file-download-line"></i>
            </div>

            <div>
              <h5 class="student-column-title">
                Select Columns
              </h5>

              <p class="student-column-subtitle">
                Choose the information you want to include
                in your ${type === "excel" ? "Excel file" : "print"}.
              </p>
            </div>
          </div>

          <div class="student-selected-count">
            <span id="selectedColumnCount">
              ${defaultSelected.length}
            </span>
            /
            ${STUDENT_COLUMNS.length}
            selected
          </div>

        </div>

        <!-- Search + Actions -->
        <div class="student-column-toolbar">

          <div class="student-column-search">
            <i class="ri-search-line"></i>

            <input
              type="text"
              id="studentColumnSearch"
              placeholder="Search columns..."
              autocomplete="off"
            />

            <button
              type="button"
              id="clearStudentColumnSearch"
              class="student-search-clear"
              style="display:none;"
            >
              <i class="ri-close-line"></i>
            </button>
          </div>

          <div class="student-column-actions">

            <button
              type="button"
              id="selectAllStudentColumns"
              class="student-column-action-btn"
            >
              <i class="ri-checkbox-multiple-line"></i>
              Select All
            </button>

            <button
              type="button"
              id="clearAllStudentColumns"
              class="student-column-action-btn"
            >
              <i class="ri-checkbox-blank-line"></i>
              Clear All
            </button>

          </div>

        </div>

        <!-- Columns -->
        <div
          id="studentColumnList"
          class="student-column-list"
        >

          ${STUDENT_COLUMNS.map(
            (col) => `
              <label
                class="student-column-item ${
                  defaultSelected.includes(col.key) ? "selected" : ""
                }"
                data-column-label="${String(col.label).toLowerCase()}"
                for="student-column-${col.key}"
              >

                <div class="student-column-check">

                  <input
                    class="student-column-checkbox"
                    type="checkbox"
                    id="student-column-${col.key}"
                    value="${col.key}"
                    ${defaultSelected.includes(col.key) ? "checked" : ""}
                  />

                  <span class="student-custom-checkbox">
                    <i class="ri-check-line"></i>
                  </span>

                </div>

                <div class="student-column-info">
                  <span class="student-column-label">
                    ${col.label}
                  </span>
                </div>

              </label>
            `,
          ).join("")}

          <div
            id="studentNoColumnResults"
            class="student-no-column-results"
            style="display:none;"
          >
            <i class="ri-search-line"></i>
            <div>
              <strong>No columns found</strong>
              <small>Try another search term.</small>
            </div>
          </div>

        </div>

        <!-- Footer Info -->
        <div class="student-column-footer-info">

          <div>
            <i class="ri-information-line"></i>
            Your column selection will be remembered for the next export.
          </div>

        </div>

      </div>

      <style>

        .student-download-popup {
          border-radius: 16px !important;
          overflow: hidden;
        }

        .student-column-selector {
          text-align: left;
          color: inherit;
        }

        /* Header */

        .student-column-header {
          padding: 22px 24px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          border-bottom: 1px solid rgba(127, 127, 127, 0.18);
        }

        .student-column-title-section {
          display: flex;
          align-items: center;
          gap: 13px;
        }

        .student-column-icon {
          width: 42px;
          height: 42px;
          min-width: 42px;
          border-radius: 10px;

          display: flex;
          align-items: center;
          justify-content: center;

          background: rgba(var(--bs-primary-rgb), 0.10);
          color: var(--bs-primary);

          font-size: 21px;
        }

        .student-column-title {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          line-height: 1.3;
        }

        .student-column-subtitle {
          margin: 3px 0 0;
          font-size: 12px;
          opacity: 0.65;
          line-height: 1.4;
        }

        .student-selected-count {
          white-space: nowrap;

          padding: 7px 11px;
          border-radius: 8px;

          font-size: 12px;
          font-weight: 600;

          background: rgba(var(--bs-primary-rgb), 0.08);
          color: var(--bs-primary);
        }

        /* Toolbar */

        .student-column-toolbar {
          padding: 14px 24px;

          display: flex;
          align-items: center;
          gap: 12px;

          border-bottom: 1px solid rgba(127, 127, 127, 0.14);
        }

        .student-column-search {
          position: relative;
          flex: 1;
        }

        .student-column-search > i {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);

          font-size: 17px;
          opacity: 0.55;

          pointer-events: none;
        }

        .student-column-search input {
          width: 100%;
          height: 40px;

          padding: 0 38px 0 37px;

          border: 1px solid rgba(127, 127, 127, 0.25);
          border-radius: 9px;

          background: transparent;
          color: inherit;

          outline: none;

          font-size: 13px;
        }

        .student-column-search input:focus {
          border-color: var(--bs-primary);
          box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.08);
        }

        .student-search-clear {
          position: absolute;

          right: 8px;
          top: 50%;
          transform: translateY(-50%);

          width: 26px;
          height: 26px;

          border: 0;
          border-radius: 6px;

          background: transparent;
          color: inherit;

          opacity: 0.6;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .student-search-clear:hover {
          opacity: 1;
          background: rgba(127, 127, 127, 0.10);
        }

        .student-column-actions {
          display: flex;
          gap: 6px;
          flex-shrink: 0;
        }

        .student-column-action-btn {
          height: 40px;

          padding: 0 11px;

          border: 1px solid rgba(127, 127, 127, 0.20);
          border-radius: 8px;

          background: transparent;
          color: inherit;

          font-size: 12px;
          font-weight: 600;

          display: flex;
          align-items: center;
          gap: 6px;

          cursor: pointer;

          transition: all 0.15s ease;
        }

        .student-column-action-btn:hover {
          background: rgba(127, 127, 127, 0.08);
          border-color: rgba(127, 127, 127, 0.35);
        }

        /* Column List */

        .student-column-list {
          padding: 14px 24px;

          max-height: 390px;
          overflow-y: auto;

          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 8px;
        }

        .student-column-list::-webkit-scrollbar {
          width: 6px;
        }

        .student-column-list::-webkit-scrollbar-track {
          background: transparent;
        }

        .student-column-list::-webkit-scrollbar-thumb {
          background: rgba(127, 127, 127, 0.30);
          border-radius: 10px;
        }

        .student-column-item {
          min-height: 48px;

          padding: 9px 11px;

          border: 1px solid rgba(127, 127, 127, 0.18);
          border-radius: 9px;

          display: flex;
          align-items: center;
          gap: 10px;

          cursor: pointer;

          transition:
            background 0.15s ease,
            border-color 0.15s ease,
            transform 0.15s ease;
        }

        .student-column-item:hover {
          background: rgba(127, 127, 127, 0.06);
          border-color: rgba(127, 127, 127, 0.30);
        }

        .student-column-item.selected {
          border-color: rgba(var(--bs-primary-rgb), 0.35);
          background: rgba(var(--bs-primary-rgb), 0.055);
        }

        .student-column-check {
          position: relative;
          width: 20px;
          height: 20px;
          min-width: 20px;
        }

        .student-column-checkbox {
          position: absolute;
          opacity: 0;
          pointer-events: none;
        }

        .student-custom-checkbox {
          width: 20px;
          height: 20px;

          border: 1.5px solid rgba(127, 127, 127, 0.40);
          border-radius: 5px;

          display: flex;
          align-items: center;
          justify-content: center;

          transition: all 0.15s ease;
        }

        .student-custom-checkbox i {
          display: none;
          font-size: 14px;
          font-weight: 700;
        }

        .student-column-checkbox:checked
          + .student-custom-checkbox {
          background: var(--bs-primary);
          border-color: var(--bs-primary);
          color: #fff;
        }

        .student-column-checkbox:checked
          + .student-custom-checkbox i {
          display: block;
        }

        .student-column-info {
          min-width: 0;
          flex: 1;
        }

        .student-column-label {
          display: block;

          font-size: 13px;
          font-weight: 500;

          line-height: 1.35;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        /* Empty Search */

        .student-no-column-results {
          grid-column: 1 / -1;

          min-height: 150px;

          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;

          text-align: left;
          opacity: 0.65;
        }

        .student-no-column-results > i {
          font-size: 28px;
        }

        .student-no-column-results strong {
          display: block;
          font-size: 13px;
        }

        .student-no-column-results small {
          display: block;
          margin-top: 2px;
          font-size: 11px;
        }

        /* Footer */

        .student-column-footer-info {
          padding: 10px 24px 14px;

          font-size: 11px;
          opacity: 0.60;

          border-top: 1px solid rgba(127, 127, 127, 0.12);
        }

        .student-column-footer-info > div {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* SweetAlert buttons */

        .student-download-confirm,
        .student-download-cancel,
        .student-download-reset {
          border-radius: 8px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          padding: 9px 15px !important;
        }

        /* Responsive */

        @media (max-width: 650px) {

          .student-column-header {
            align-items: flex-start;
            flex-direction: column;
            gap: 10px;
          }

          .student-selected-count {
            align-self: flex-start;
          }

          .student-column-toolbar {
            flex-direction: column;
            align-items: stretch;
          }

          .student-column-actions {
            width: 100%;
          }

          .student-column-action-btn {
            flex: 1;
            justify-content: center;
          }

          .student-column-list {
            grid-template-columns: 1fr;
            padding-left: 16px;
            padding-right: 16px;
          }

          .student-column-header,
          .student-column-toolbar {
            padding-left: 16px;
            padding-right: 16px;
          }

          .student-column-footer-info {
            padding-left: 16px;
            padding-right: 16px;
          }
        }

      </style>
    `,

    didOpen: () => {
      const searchInput = document.getElementById("studentColumnSearch");

      const clearSearch = document.getElementById("clearStudentColumnSearch");

      const selectAllButton = document.getElementById(
        "selectAllStudentColumns",
      );

      const clearAllButton = document.getElementById("clearAllStudentColumns");

      const countElement = document.getElementById("selectedColumnCount");

      const noResults = document.getElementById("studentNoColumnResults");

      const getCheckboxes = () =>
        Array.from(document.querySelectorAll(".student-column-checkbox"));

      const updateCount = () => {
        const checkboxes = getCheckboxes();

        const selectedCount = checkboxes.filter(
          (checkbox) => checkbox.checked,
        ).length;

        if (countElement) {
          countElement.textContent = selectedCount;
        }

        checkboxes.forEach((checkbox) => {
          const item = checkbox.closest(".student-column-item");

          if (item) {
            item.classList.toggle("selected", checkbox.checked);
          }
        });
      };

      const filterColumns = () => {
        const searchValue = searchInput?.value?.trim()?.toLowerCase() || "";

        const items = Array.from(
          document.querySelectorAll(".student-column-item"),
        );

        let visibleCount = 0;

        items.forEach((item) => {
          const label = item.dataset.columnLabel || "";

          const matches = !searchValue || label.includes(searchValue);

          item.style.display = matches ? "flex" : "none";

          if (matches) {
            visibleCount++;
          }
        });

        if (clearSearch) {
          clearSearch.style.display = searchValue ? "flex" : "none";
        }

        if (noResults) {
          noResults.style.display = visibleCount === 0 ? "flex" : "none";
        }
      };

      searchInput?.addEventListener("input", filterColumns);

      clearSearch?.addEventListener("click", () => {
        if (searchInput) {
          searchInput.value = "";
          searchInput.focus();
        }

        filterColumns();
      });

      selectAllButton?.addEventListener("click", () => {
        getCheckboxes().forEach((checkbox) => {
          checkbox.checked = true;
        });

        updateCount();
      });

      clearAllButton?.addEventListener("click", () => {
        getCheckboxes().forEach((checkbox) => {
          checkbox.checked = false;
        });

        updateCount();
      });

      document
        .querySelectorAll(".student-column-checkbox")
        .forEach((checkbox) => {
          checkbox.addEventListener("change", updateCount);
        });

      updateCount();
    },

    preConfirm: () => {
      const selected = STUDENT_COLUMNS.filter(
        (col) => document.getElementById(`student-column-${col.key}`)?.checked,
      );

      if (!selected.length) {
        Swal.showValidationMessage("Please select at least one column.");

        return false;
      }

      sessionStorage.setItem(
        COLUMN_STORAGE_KEY,
        JSON.stringify(selected.map((c) => c.key)),
      );

      return selected;
    },
  });

  // Cancel
  if (popup.isDismissed) {
    return;
  }

  // Reset
  if (popup.isDenied) {
    sessionStorage.removeItem(COLUMN_STORAGE_KEY);

    return handleStudentDownload(type, setLoading, filters);
  }

  const selectedColumns = popup.value;

  setLoading(true);

  try {
    let firstUrl = "";

    const downloadData = [];

    Object.keys(filters).forEach((key) => {
      const value = filters[key];

      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        key !== "page"
      ) {
        firstUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    // First Page
    const firstResponse = await studentsList(`page=1${firstUrl}`);

    if (!firstResponse?.data?.status) {
      SweetAlertShow("info", "Warning", firstResponse?.data?.message);

      return;
    }

    const lastPage = firstResponse?.data?.data?.last_page || 1;

    // Map rows
    const mapRows = (items) =>
      items.map((item) => {
        const row = {};

        selectedColumns.forEach((column) => {
          row[column.label] = column.value(item);
        });

        return row;
      });

    downloadData.push(...mapRows(firstResponse?.data?.data?.data || []));

    // Remaining Pages
    for (let page = 2; page <= lastPage; page++) {
      const response = await studentsList(`page=${page}${firstUrl}`);

      if (response?.data?.status) {
        downloadData.push(...mapRows(response?.data?.data?.data || []));
      }
    }

    if (!downloadData.length) {
      SweetAlertShow("info", "Info", "No records found.");

      return;
    }

    // Excel
    if (type === "excel") {
      const now = new Date();

      const fileName =
        `Students_${now.getFullYear()}_` +
        `${now.getMonth() + 1}_` +
        `${now.getDate()}_` +
        `${now.getHours()}_` +
        `${now.getMinutes()}`;

      DownloadExcel(downloadData, [], fileName, []);
    } else {
      // Print
      PrintPage(downloadData);
    }
  } catch (err) {
    SweetAlertShow(
      "error",
      "Error",
      err?.response?.data?.message || err?.message,
    );
  } finally {
    setLoading(false);
  }
};
